(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('submitForAnalysisParams', ["modals", "emailDao", "$q", "modulesDao", "entityTypes", function (modals, emailDao, $q, modulesDao, entityTypes) {
        return {
            show: function (title, type, entityType, entityId, args) {
                var entitySaas = entityTypes.toSaas(entityType) || args.saas || args.objectTypesData && args.objectTypesData.entities[entityType].saas;
                var localEntity = entityTypes.toLocal(entityType);
                var getEntityInfo;
                if (args.secTypes) {
                    getEntityInfo = $q.when({ sec_type_connected: secTypes });
                } else {
                    if (localEntity === 'file' || localEntity === 'email') {
                        getEntityInfo = $q.when();
                    } else {
                        if (entitySaas) {
                            getEntityInfo = modulesDao.entityInfoRaw(entitySaas, entityType);
                        } else {
                            getEntityInfo = $q.when();
                        }
                    }
                }
                return getEntityInfo.then(function (data) {
                    var secTypes = data && data.sec_type_connected || [];
                    var variants = [
                        {
                            id: 'clean',
                            label: 'Clean'
                        },
                        {
                            id: 'unknown',
                            label: 'Unknown'
                        }
                    ];
                    if (type !== 'email' && type !== 'file' && _(secTypes).contains('dlp')) {
                        variants.unshift({
                            id: 'leak',
                            label: 'Containing sensitive data'
                        });
                    }
                    if (type === 'email' || _(secTypes).contains('ap')) {
                        variants.unshift({
                            id: 'leak',
                            label: 'Containing sensitive data'
                        });
                        variants.unshift({
                            id: 'spam',
                            label: 'Spam'
                        });
                        variants.unshift({
                            id: 'marketing',
                            label: 'Marketing'
                        });
                        variants.unshift({
                            id: 'phishing',
                            label: 'Phishing'
                        });
                    }
                    if (type === 'file' || _(secTypes).contains('av')) {
                        variants.unshift({
                            id: 'leak',
                            label: 'Containing sensitive data'
                        });
                        variants.unshift({
                            id: 'malicious',
                            label: 'Malicious'
                        });
                    }
                    var makeLabel = function (mode) {
                        if (mode === 'email') {
                            return 'I think this email is ';
                        } else if (mode === 'file') {
                            return 'I think this file is ';
                        } else {
                            return 'I think this is ';
                        }
                    };
                    var params = [{
                            id: 'status',
                            type: 'selector',
                            label: makeLabel(type),
                            variants: variants,
                            data: variants[0].id
                        }];
                    params.push({
                        id: 'submitReason',
                        type: 'text',
                        label: 'Comments',
                        paramClass: 'text-param-average',
                        validation: { required: true }
                    });
                    return modals.params([{
                            lastPage: true,
                            params: params
                        }], title);
                });
            }
        };
    }]);
}());